import { motion } from "framer-motion";
import type { Route } from "../../+types/layout";
import ResetPasswordForm from "./form";
import { useModal } from "@/hooks/modal-hooks";
import { ssoApi } from "@/redux/sso/sso-api";
import React from "react";
import VerifyAccountForm from "../verify-account/form";

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Nettpay" },
    { name: "description", content: "Nettpay | Create A New Nettpay Account" },
  ];
}

const ResetPassword = () => {
  const otpVerificationPage = useModal();
  const [submittedData, setSubmittedData] =
    React.useState<SSOResendVerificationPayload | null>(null);

  const [resetPassword, { isLoading, isSuccess, isError, error }] =
    ssoApi.useResendVerificationMutation();

  const onSubmit = async (data: SSOResendVerificationPayload) => {
    setSubmittedData(data);
    await resetPassword(data).unwrap();
  };

  React.useEffect(() => {
    if (isSuccess) {
      otpVerificationPage.toggle(true);
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (!otpVerificationPage.open) setSubmittedData(null);
  }, [otpVerificationPage.open]);

  return (
    <motion.div
      className="flex-1 p-8 md:p-12 bg-white backdrop-blur-lg h-fit rounded-xl"
      style={{ boxShadow: "0px 4px 10px 0px #3182CE" }}
      initial={{ opacity: 0, x: 200 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h2 className="text-2xl font-bold mb-12 text-gray-800">Reset Password</h2>
      {otpVerificationPage.open && submittedData ? (
        <VerifyAccountForm
          ctaText="Reset Password"
          nextPage="/auth/login"
          verificationType="reset_password"
          username={submittedData.username}
          toggleVisiblity={() => otpVerificationPage.toggle(false)}
        />
      ) : (
        <ResetPasswordForm
          handleResetPassword={onSubmit}
          isError={isError}
          error={error}
          isLoading={isLoading}
        />
      )}
    </motion.div>
  );
};

export default ResetPassword;
